import { render, staticRenderFns } from "./ClockFaceIcon.vue?vue&type=template&id=78205553&"
import script from "./ClockFaceIcon.vue?vue&type=script&lang=js&"
export * from "./ClockFaceIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports